import { useState } from 'react';
import { useGoogleIdPSync, useGoogleIdPSyncDryRun } from '#api/google-idp.queries.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { GoogleDirectorySyncDialog } from './GoogleDirectorySyncDialog.tsx';

type Props = {
  variant?: 'primary' | 'secondary';
  /** Matches the buttons beside it, such as a page header's small ones */
  size?: 'small' | 'medium';
  disabled?: boolean;
};

/** {@link GoogleDirectorySyncButton} runs a full Google Workspace user sync and shows what it changed. */
export function GoogleDirectorySyncButton({ variant = 'secondary', size, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const dryRun = useGoogleIdPSyncDryRun();
  const sync = useGoogleIdPSync();

  // Started from the click, not from an effect in the dialog; see GoogleDirectorySyncDialog's props for why.
  function start() {
    dryRun.reset();
    sync.reset();
    sync.mutate({});
    setOpen(true);
  }

  return (
    <>
      <Button variant={variant} size={size} onClick={start} disabled={disabled}>
        Sync now
      </Button>
      {open ?
        <GoogleDirectorySyncDialog onClose={() => setOpen(false)} dryRun={dryRun} sync={sync} />
      : null}
    </>
  );
}
